<template>
  <div class="admin-game-buddy-manager-container">
    <el-card class="manager-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span class="header-title">陪玩选手管理</span>
        <el-button type="primary" class="add-btn" @click="showAddDialog">
          <i class="el-icon-plus"></i> 添加陪玩选手
        </el-button>
      </div>
      
      <div class="game-buddy-table">
        <el-table :data="gameBuddies" style="width: 100%" stripe highlight-current-row>
          <el-table-column prop="id" label="选手ID" width="100" align="center"></el-table-column>
          <el-table-column prop="name" label="选手名称" width="150" align="center"></el-table-column>
          <el-table-column prop="expertise" label="游戏专长" min-width="200"></el-table-column>
          <el-table-column prop="introduction" label="选手介绍" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.introduction || '暂无介绍' }}
            </template>
          </el-table-column>
          <el-table-column label="陪玩价格" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.price || 100 }}/小时
            </template>
          </el-table-column>
          <el-table-column label="可陪玩时间" min-width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.timeSlots && scope.row.timeSlots.length > 0">
                {{ formatTimeSlots(scope.row.timeSlots) }}
              </span>
              <span v-else style="color: #999;">未设置</span>
            </template>
          </el-table-column>
          <el-table-column prop="approvalStatus" label="审核状态" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.approvalStatus === 1 ? 'success' : 'warning'" size="mini">
                {{ scope.row.approvalStatus === 1 ? '已通过' : '待审核' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" @click="deleteGameBuddy(scope.row.id)">删除</el-button>
              <el-button 
                v-if="scope.row.approvalStatus === 0" 
                type="success" 
                size="mini" 
                @click="approveGameBuddy(scope.row.id)"
              >
                审核通过
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        ></el-pagination>
      </div>
    </el-card>
    
    <!-- 添加/编辑陪玩选手对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      center
    >
      <el-form :model="gameBuddyForm" :rules="rules" ref="gameBuddyForm" label-width="100px">
        <el-form-item label="选手名称" prop="username">
          <el-input
            v-model="gameBuddyForm.username"
            placeholder="请输入选手名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="游戏专长" prop="expertise">
          <el-input v-model="gameBuddyForm.expertise" placeholder="请输入游戏专长，多个游戏用逗号分隔"></el-input>
        </el-form-item>
        <el-form-item label="选手介绍" prop="introduction">
          <el-input
            v-model="gameBuddyForm.introduction"
            type="textarea"
            :rows="5"
            placeholder="请输入选手介绍（选填）"
          ></el-input>
        </el-form-item>
        <el-form-item label="陪玩价格" prop="price">
          <el-input-number
            v-model="gameBuddyForm.price"
            :min="0"
            :step="50"
            placeholder="请输入陪玩价格"
            style="width: 100%"
          ></el-input-number>
          <div style="margin-top: 5px; color: #909399; font-size: 12px;">单位：元/小时</div>
        </el-form-item>
        <el-form-item label="可陪玩时间">
          <div class="time-slot-simple">
            <el-time-picker
              v-model="gameBuddyForm.startTime"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="开始时间"
              style="width: 150px;"
            ></el-time-picker>
            <span style="margin: 0 10px;">-</span>
            <el-time-picker
              v-model="gameBuddyForm.endTime"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="结束时间"
              style="width: 150px;"
            ></el-time-picker>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdminGameBuddyManager',
  data() {
    return {
      gameBuddies: [],
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '添加陪玩选手',
      gameBuddyForm: {
        id: null,
        username: '',
        expertise: '',
        introduction: '',
        price: 100,
        startTime: '',
        endTime: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入选手名称', trigger: 'blur' }
        ],
        expertise: [
          { required: true, message: '请输入游戏专长', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        introduction: [
          { min: 0, max: 500, message: '长度在 0 到 500 个字符', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入陪玩价格', trigger: 'blur' },
          { type: 'number', min: 0, message: '价格不能为负数', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchGameBuddies()
  },
  methods: {
    fetchGameBuddies() {
      // 管理后台获取所有陪玩选手（包括待审核的）
      this.$axios.get('/game-buddy/admin/list').then(res => {
        console.log('Game buddies response:', res);
        if (res.data && res.data.data) {
          this.gameBuddies = res.data.data
          this.total = res.data.data.length
        } else {
          this.gameBuddies = res.data || []
          this.total = this.gameBuddies.length
        }
      }).catch(error => {
        this.$message.error('加载陪玩选手列表失败')
        console.error('Fetch game buddies error:', error)
      })
    },
    showAddDialog() {
      this.dialogTitle = '添加陪玩选手'
      this.gameBuddyForm = {
        id: null,
        username: '',
        expertise: '',
        introduction: '',
        price: 100,
        startTime: '',
        endTime: ''
      }
      this.dialogVisible = true
    },
    showEditDialog(gameBuddy) {
      this.dialogTitle = '编辑陪玩选手'
      console.log('Editing game buddy:', gameBuddy) // 调试信息
      // 从timeSlots中提取第一个时间段的开始和结束时间
      let startTime = ''
      let endTime = ''
      if (gameBuddy.timeSlots && gameBuddy.timeSlots.length > 0) {
        startTime = gameBuddy.timeSlots[0].startTime || ''
        endTime = gameBuddy.timeSlots[0].endTime || ''
      }
      this.gameBuddyForm = {
        id: gameBuddy.id,
        username: gameBuddy.name || '', // 使用name字段作为username
        expertise: gameBuddy.expertise || '',
        introduction: gameBuddy.introduction || '',
        price: gameBuddy.price || 100,
        startTime: startTime,
        endTime: endTime
      }
      console.log('Form data:', this.gameBuddyForm) // 调试信息
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs.gameBuddyForm.validate((valid) => {
        if (valid) {
          // 准备发送给后端的数据,只包含GameBuddy实体中存在的字段
          const submitData = {
            id: this.gameBuddyForm.id,
            userId: null, // 不再关联用户ID
            name: this.gameBuddyForm.username, // 直接使用username作为name
            expertise: this.gameBuddyForm.expertise,
            introduction: this.gameBuddyForm.introduction,
            price: this.gameBuddyForm.price
          }
          
          // 保存或更新陪玩选手信息
          const savePromise = this.gameBuddyForm.id
            ? this.$axios.put(`/game-buddy/update/${this.gameBuddyForm.id}`, submitData)
            : this.$axios.post('/game-buddy/create', submitData)
          
          savePromise
            .then(res => {
              const gameBuddyId = this.gameBuddyForm.id || res.data
              // 保存时间槽（只有填写了时间才保存）
              if (this.gameBuddyForm.startTime && this.gameBuddyForm.endTime) {
                const timeSlots = [{
                  gameBuddyId: gameBuddyId,
                  dayOfWeek: 0, // 不再使用周几，设置为0
                  startTime: this.gameBuddyForm.startTime,
                  endTime: this.gameBuddyForm.endTime
                }]
                return this.$axios.post('/game-buddy/time-slot/save', timeSlots)
                  .then(() => {
                    this.$message.success(this.gameBuddyForm.id ? '更新陪玩选手成功' : '添加陪玩选手成功')
                    this.dialogVisible = false
                    this.fetchGameBuddies()
                  })
              } else {
                this.$message.success(this.gameBuddyForm.id ? '更新陪玩选手成功' : '添加陪玩选手成功')
                this.dialogVisible = false
                this.fetchGameBuddies()
              }
            })
            .catch(error => {
              this.$message.error(this.gameBuddyForm.id ? '更新陪玩选手失败' : '添加陪玩选手失败')
              console.error('Save game buddy error:', error)
            })
        }
      })
    },
    deleteGameBuddy(id) {
      this.$confirm('确定要删除这个陪玩选手吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete(`/game-buddy/delete/${id}`).then(res => {
          this.$message.success('删除陪玩选手成功')
          this.fetchGameBuddies()
        }).catch(error => {
          this.$message.error('删除陪玩选手失败')
          console.error('Delete game buddy error:', error)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    approveGameBuddy(id) {
      this.$confirm('确定要审核通过这个陪玩选手吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        this.$axios.put(`/game-buddy/status/${id}`, {}, {
          params: { status: 1 }
        }).then(res => {
          this.$message.success('审核通过成功')
          this.fetchGameBuddies()
        }).catch(error => {
          this.$message.error('审核通过失败')
          console.error('Approve game buddy error:', error)
        })
      }).catch(() => {
        this.$message.info('已取消审核')
      })
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchGameBuddies()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.fetchGameBuddies()
    },
    formatTimeSlots(timeSlots) {
      if (!timeSlots || timeSlots.length === 0) {
        return '未设置'
      }
      // 只显示第一个时间段的开始和结束时间
      const slot = timeSlots[0]
      return `${slot.startTime}-${slot.endTime}`
    }
  }
}
</script>

<style scoped>
.admin-game-buddy-manager-container {
  padding: 20px 0;
}

.manager-card {
  margin-bottom: 20px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.add-btn {
  float: right;
}

.search-container {
  margin-bottom: 20px;
}

.search-input {
  width: 300px;
}

.game-buddy-table {
  margin-bottom: 20px;
}

.introduction-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: 3em;
}

.pagination-container {
  text-align: right;
}

.time-slot-simple {
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .search-input {
    width: 100%;
  }
}
</style>
